import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWrapper from './ModalWrapper';
import ModalCloseButton from './ModalCloseButton';
import Button from './Button';

/**
 * Common search-filter bottom-sheet wrapper.
 * Renders title, close button, children (filter fields), and 초기화/검색 buttons.
 *
 * @param {function} onClose - close the sheet
 * @param {function} onReset - reset all filter fields
 * @param {function} onSearch - apply filters (defaults to onClose)
 * @param {ReactNode} children - filter field rows
 */
export default function SearchFilterSheet({ onClose, onReset, onSearch, children }) {
  const { t } = useTranslation();
  return (
    <ModalWrapper onClose={onClose} position="bottom" padding="p-5" gap="gap-2.5">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-bold text-mono-900">{t('common.search_filter_title')}</h2>
        <ModalCloseButton onClick={onClose} />
      </div>

      {children}

      <div className="flex gap-2.5">
        <Button level="level3" size="lg" onClick={onReset} className="!w-[100px] shrink-0">{t('common.reset')}</Button>
        <Button level="dark" size="lg" fullWidth onClick={onSearch || onClose}>{t('common.search')}</Button>
      </div>
    </ModalWrapper>
  );
}
